export const getPreviewSectionId = (sections = [], sectionKey) =>
	sections.find((section) => section.key === sectionKey)?.id;
